import {useContext, useState} from "react";
import {Button, Form} from "react-bootstrap";
import logoWhite from '../assets/img/logo-white.png'
import logo from '../assets/img/logo.png'
import './Login.css'
import API, {getMe, HandleError} from "../API";
import AppContext from "../AppContext";
import {useSnackbar} from "notistack";
import {Link, Navigate} from "react-router-dom";
import {useTranslation} from "react-i18next";

export default function Signup() {
    const { t, i18n } = useTranslation();
    const { enqueueSnackbar } = useSnackbar()
    const app = useContext(AppContext)
    const [form, setForm] = useState({
        values: {
            first_name: '',
            last_name: '',
            email: '',
            password: '',
            phone: ''
        },
        errorFields: {},
        error: false,
        loading: false,
    })

    const [redirect, setRedirect] = useState('')

    const handleSubmit = async (e) => {
        e.preventDefault();
        if(!form.values.email || !form.values.password || !form.values.first_name || !form.values.last_name || !form.values.phone)
            return;

        setForm({...form, loading: true })
        try {
            const resMe = await API({
                method: 'POST',
                url: `/signup`,
                data: {...form.values}
            })

            //console.log(resMe)

            if (resMe.status < 200 || resMe.status > 299)
                throw resMe.data;

            setForm({...form, loading: false})
            app.login(resMe.data.token, resMe.data.me, {...app.ui, ...resMe.data.ui})
            //console.log(resMe.data.redirect)
            setRedirect(resMe.data.redirect ? resMe.data.redirect : '/')
        }
        catch(e) {
            setForm({...form, loading: false})
            HandleError(e, 'Error', enqueueSnackbar, app.logout);
        }
    }

    const onChange = (e) => {
        let values = {...form.values}
        values[e.target.name] = e.target.value
        setForm({...form, values: values})
    }

    return (redirect ? <Navigate to={redirect} /> : <div id="page-login">
        <div className="login-banner">
            <div className="center-logo">
                <img src={logoWhite} alt=""/>
            </div>
            <h1>{t('login.heading')}</h1>
        </div>
        <div className="login-form-box">
            <div className="form-inner">
                <div className="login-logo">
                    <img src={logo} alt="" />
                </div>
                <div className="form-login">
                    <h3 className="mb-4">{t('signup.title')}</h3>
                    <form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3 form-floating" controlId="first_name">
                            <Form.Control type="text" placeholder={t('form.firstName')} name="first_name" value={form.values.first_name} onChange={onChange} />
                            <Form.Label>{t('form.firstName')}</Form.Label>
                            {'first_name' in form.errorFields ? <Form.Text className="text-muted">
                                {form.errorFields['first_name']}
                            </Form.Text> : ''}
                        </Form.Group>
                        <Form.Group className="mb-5 form-floating" controlId="last_name">
                            <Form.Control type="text" placeholder={t('form.lastName')} name="last_name" value={form.values.last_name} onChange={onChange} />
                            <Form.Label>{t('form.lastName')}</Form.Label>
                            {'last_name' in form.errorFields ? <Form.Text className="text-muted">
                                {form.errorFields['last_name']}
                            </Form.Text> : ''}
                        </Form.Group>
                        <Form.Group className="mb-3 form-floating" controlId="email">
                            <Form.Control type="email" placeholder={t('form.email')} name="email" value={form.values.email} onChange={onChange} />
                            <Form.Label>{t('form.email')}</Form.Label>
                            {'email' in form.errorFields ? <Form.Text className="text-muted">
                                {form.errorFields['email']}
                            </Form.Text> : ''}
                        </Form.Group>
                        <Form.Group className="mb-5 form-floating" controlId="password">
                            <Form.Control type="password" placeholder={t('form.password')} name="password" value={form.values.password} onChange={onChange} />
                            <Form.Label>{t('form.password')}</Form.Label>
                            {'password' in form.errorFields ? <Form.Text className="text-muted">
                                {form.errorFields['password']}
                            </Form.Text> : ''}
                        </Form.Group>
                        <Form.Group className="mb-3 form-floating" controlId="phone">
                            <Form.Control type="text" placeholder={t('form.mobile')} name="phone" value={form.values.phone} onChange={onChange} />
                            <Form.Label>{t('form.mobile')}</Form.Label>
                            {'phone' in form.errorFields ? <Form.Text className="text-muted">
                                {form.errorFields['phone']}
                            </Form.Text> : ''}
                        </Form.Group>
                        <Button color={"primary"} type="submit">{t('button.signup')}</Button>
                    </form>
                </div>
                <div className="login-options">
                    <p>
                        {t('login.alreadyHaveAccount')}
                        <br />
                        <Link to="/login"><strong>{t('button.login')}</strong></Link>
                    </p>
                    <p className="text-center text-muted small pt-5 pb-5">
                        &copy; TurboTheorie B.V.
                    </p>
                </div>
            </div>
        </div>
    </div>)
}